import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import DisabledImage from "../../../../src/Resources/Images/disable.png";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { visuallyHidden } from "@mui/utils";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../../UiComponents/Transition/Transition";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";
import {
  SearchIcon,
  EditIcon,
  DownloadIcon,
  CloudOffIcon,
  RestartAltIcon,
  DeleteIcon,
  NotInterestedIcon,
  AddIcon,
} from "../../../Resources/Icons/icons";
import moment from "moment";
import AddReceivableConfig from "./AddReceivableConfig";
import {
  GetUser,
  GetCompany,
  GetBookingCode,
  GetPolicyFindbyId,
  FilterPolicyList,
  GetReceivableConfigByCompanyId,
  GetSubBookingCode,
  DisableReceivableConfig,
  DeleteReceivableConfigById,
  GetReceivableConfigById,
} from "../../../Service/_index";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PolicyFilterTypes } from "../../../Shared/CommonConstant";
import Loader from "../../../UiComponents/Loader/Loader";
import { DatePicker, Radio } from "antd";
import { CSVLink } from "react-csv";
import { useEffect } from "react";
import dayjs from "dayjs";
import {
  deleteMultipleReceivableConfigById,
  disableMultipleReceivableConfigById,
} from "../../../Service/ReceivableConfigService";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import FilterBox from "../../../UiComponents/FilterBox/FilterBox";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import TabFilter from "../../Tabs/Tabs";
import { Divider, Stack, Badge } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ViewColumnOutlinedIcon from "@mui/icons-material/ViewColumnOutlined";

const { RangePicker } = DatePicker;

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const getHeadCells = (selectedTab) => {
  const allCells = [
    {
      id: "company",
      placeMent: true,
      disablePadding: false,
      label: "Company Name",
    },
    {
      id: "bookingCode",
      placeMent: true,
      disablePadding: false,
      label: "Booking - Sub Booking",
    },
    // {
    //   id: "subBookingCode",
    //   placeMent: true,
    //   disablePadding: false,
    //   label: "Sub Booking Code",
    // },
    {
      id: "product",
      placeMent: true,
      disablePadding: false,
      label: "Product - Sub Product",
    },
    // {
    //   id: "subProduct",
    //   placeMent: true,
    //   disablePadding: false,
    //   label: "Sub Product",
    // },
    {
      id: "policyType",
      placeMent: true,
      disablePadding: false,
      label: "Policy Type",
    },
    {
      id: "CC",
      placeMent: true,
      disablePadding: false,
      label: "CC / GVW",
    },
    // {
    //   id: "GVW",
    //   placeMent: true,
    //   disablePadding: false,
    //   label: "GVW",
    // },
    {
      id: "location",
      placeMent: true,
      disablePadding: false,
      label: "RTO Code",
    },
    {
      id: "PACover",
      placeMent: true,
      disablePadding: false,
      label: "PA Cover",
    },
    {
      id: "OD",
      placeMent: true,
      disablePadding: false,
      label: "OD %",
    },
    {
      id: "TP",
      placeMent: true,
      disablePadding: false,
      label: "TP %",
    },
    {
      id: "Net",
      placeMent: true,
      disablePadding: false,
      label: "NET %",
    },
    {
      id: "ActiveDate",
      placeMent: true,
      disablePadding: false,
      label: "Active Date",
    },
    {
      id: "DisableDate",
      placeMent: true,
      disablePadding: false,
      label: "Disable Date",
    },
  ];

  // Filter out DisableDate column when Active tab (value 1) is selected
  if (selectedTab === 1) {
    return allCells.filter(cell => cell.id !== "DisableDate");
  }

  return allCells;
};

const FilterOption = [
  {
    label: "ActiveData",
    isEnabled: "true",
    value: 1,
  },
  {
    label: "In ActiveData",
    isEnabled: "false",
    value: 2,
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, headCells } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const ReceivableConfig = () => {
  const todayDate = new Date();
  const LastWeekDate = new Date();
  LastWeekDate.setDate(LastWeekDate.getDate() - 7);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [selectedData, setSelectedData] = React.useState({});
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [policyList, setPolicyList] = React.useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [subBookingCodeDetails, setSubBookingCodeDetails] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);
  const [formType, setFormType] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  console.log(selectedCompany, "SC");
  const [selectedBookingCode, setSelectedBookingCode] = useState(null);
  const [selectedSubBookingCode, setSelectedSubBookingCode] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState();
  const [selectedEndDate, setSelectedEndDate] = useState();
  const [resetValue, setResetValue] = useState(1);
  const [payableType, setPayableType] = useState("");
  const [openMultipleDeleteConfirmBox, setOpenMultipleDeleteConfirmBox] =
    React.useState(false);
  const [checkedRows, setCheckedRows] = useState([]);
  const [checkboxRows, setCheckboxRows] = useState({});
  const [selectedUser, setSelectedUser] = useState(null);
  const [disabledDate, setDisabledDate] = useState("React-disable");
  const [openConfirmBox, setOpenConfirmBox] = React.useState(false);
  const [openDeleteConfirmBox, setOpenDeleteConfirmBox] = React.useState(false);
  const [reqType, setReqType] = useState(null);
  const lastApiCallParamsRef = useRef(null);
  const filterDebounceTimeoutRef = useRef(null);

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [selectedTab, setSelectedTab] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedItems, setSelectedItems] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    // isView: true,
    isEdit: true,
    isDelete: true,
    isSearch: true,
    isSwitch: true,
    isMultiDelete: true,
    type: "userConfiguration",
  });

  const FilteredData = policyList.filter((el) => {
    const searchTerm = searchText.toLowerCase();
    const policyListDetails =
      `${el?.user},${el?.company},${el?.bookingCode},${el?.product},${el?.policyType},${el?.location}`.toLowerCase();
    return policyListDetails.includes(searchTerm);
  });

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    console.log(newValue, "VS");
    const selectedOption = FilterOption.find(
      (option) => option.value === newValue
    );
    if (selectedOption.value === 1) {
      ActiveFunction();
    } else if (selectedOption.value === 2) {
      DisableFunction();
    }
  };

  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(policyList), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, policyList]
  );

  {
    /*changes by sankarNagarajan */
  }
  const checked = (checked, id, index) => {
    setCheckboxRows((prev) => ({ ...prev, [index]: checked }));
    checked
      ? checkedRows.push(id)
      : checkedRows.splice(checkedRows.indexOf(id), 1);
    console.log("checked rows ", checkedRows);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - policyList.length) : 0;

  const ApproveFunction = (row) => {
    setOpenLoader(true);
    GetPolicyFindbyId(row._id).then((res) => {
      setOpenLoader(false);
      setSelectedData(res.data);
      setOpenDrawer(true);
      setFormType("edit");
      setPayableType("branchPayable");
    });
  };

  const onSearch = (e) => {
    let target = e.target;
    setFilter({
      fn: (items) => {
        if (target.value == "") return items;
        else
          return items.filter((el) =>
            `${el?.user},${el?.company},${el?.bookingCode},${el?.subBookingCode
              },${el?.product},${el?.subProduct},${el?.policyType},${el?.CC},${el?.PACover
              },${el?.OD},${el?.TP},${el?.Net},${moment(el?.disableDate).format(
                "DD/MM/YYYY"
              )},${moment(el?.activeDate).format("DD/MM/YYYY")}`
              .toLowerCase()
              .includes(target.value.toLowerCase())
          );
      },
    });
    setPage(0);
  };

  const GetCompanyDetails = () => {
    GetCompany({ isAscending: true }).then((res) => {
      const modifiedCompanyDetails = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.shortName,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setCompanyDetails(modifiedCompanyDetails);
    });
  };

  const GetBookingCodeDetails = () => {
    GetBookingCode({ isAscending: true }).then((res) => {
      const modifiedBookingCode = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.bookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setBookingCodeDetails(modifiedBookingCode);
    });
  };

  const GetSubBookingCodeDetails = () => {
    GetSubBookingCode({ isAscending: true }).then((res) => {
      const modifiedSubBookingCode = res.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.subBookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      const FilteredSubBookingCode = modifiedSubBookingCode.filter(
        (item) =>
          item.bookingCodeId === selectedBookingCode?._id ||
          item.bookingCodeId === selectedBookingCode
      );
      setSubBookingCodeDetails(FilteredSubBookingCode);
    });
  };

  React.useEffect(() => {
    GetCompanyDetails();
    GetBookingCodeDetails();
  }, []);

  React.useEffect(() => GetSubBookingCodeDetails(), [selectedBookingCode]);

  const GetData = () => {
    setOpenLoader(true);
    FilterPolicyList({
      companyId: selectedCompany?._id,
      bookingCodeId: selectedBookingCode?._id,
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      FilterType: "UTILITES_SCREEN",
      screen: "BRANCH_PAYABLE",
    })
      .then((res) => {
        setPolicyList(res.data);
      })
      .catch((err) => {
        console.log("err");
      }).finally(() => {
        setOpenLoader(false);
      });
  };

  const ResetFilter = () => {
    setSelectedCompany(null);
    setSelectedBookingCode(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setResetValue(resetValue + 1);
    GetData();
  };

  const header = [
    // { label: "User", key: "user" },
    { label: "Company Name", key: "company" },
    { label: "Booking Code", key: "bookingCode" },
    { label: "Sub Booking Code", key: "subBookingCode" },
    { label: "Product", key: "product" },
    { label: "Sub Product", key: "subProduct" },
    { label: "Policy Type", key: "policyType" },
    { label: "CC", key: "CC" },
    { label: "GVW", key: "GVW" },
    { label: "RTO Code", key: `location` },
    { label: "PA Cover", key: "PACover" },
    { label: "OD%", key: "OD" },
    { label: "TP%", key: "TP" },
    { label: "NET%", key: "Net" },
    { label: "Active Date", key: "ActiveDate" },
    { label: "Disable Date", key: "DisableDate" },
  ];
  const csvFile = {
    filename: "Recieve Payable Data",
    headers: header,
    data: policyList,
  };

  const ActiveFunction = () => {
    setOpenLoader(true);
    setReqType("ACTIVE");
    const requestType = "ACTIVE";
    const companyId = selectedCompany?._id || selectedCompany;
    // Use "undefined" string to get all data when no company is selected
    const finalCompanyId =
      companyId === null || companyId === undefined ? "undefined" : companyId;
    console.log("activeeeeeeeeee", finalCompanyId);
    GetReceivableConfigByCompanyId(finalCompanyId, {
      requestType,
      bookingCodeId: selectedBookingCode?._id,
      subBookingCodeId: selectedSubBookingCode?._id,
    }).then((res) => {
      const data = res.data.map((e) => {
        return {
          ...e,
          ActiveDate: moment(e.activeDate).format("DD/MM/YYYY"),
        };
      });
      setPolicyList(data);
    })
      .finally(() => {
        setOpenLoader(false);
      });
    setPage(0);
  };

  const DisableFunction = () => {
    setOpenLoader(true);
    setReqType("DISABLED");
    const requestType = "DISABLED";
    const companyId = selectedCompany?._id || selectedCompany;
    // Use "undefined" string to get all data when no company is selected
    const finalCompanyId =
      companyId === null || companyId === undefined ? "undefined" : companyId;
    console.log("disableeeeeeeeee", finalCompanyId);
    GetReceivableConfigByCompanyId(finalCompanyId, {
      requestType,
      bookingCodeId: selectedBookingCode?._id,
      subBookingCodeId: selectedSubBookingCode?._id,
    }).then((res) => {
      const data = res.data.map((e) => {
        return {
          ...e,
          ActiveDate: moment(e.activeDate).format("DD/MM/YYYY"),
          DisableDate: moment(e.disableDate).format("DD/MM/YYYY"), //Changes by Arun
        };
      });
      setPolicyList(data);
    })
      .finally(() => {
        setOpenLoader(false);
      });
    setPage(0);
  };

  {
    /*changes by sankarNagarajan */
  }
  const DisableMultipleReceivableConfigData = (row) => {
    if (checkedRows.length == 0) {
      ToastError("Please select record");
    } else {
      setDisabledDate("React-disable");
      setOpenConfirmBox(true);
    }
  };

  const DisableReceivableConfigData = (row) => {
    setDisabledDate("React-disable");
    setOpenConfirmBox(true);
    setSelectedData(row);
  };

  {
    /*changes by sankarNagarajan */
  }
  const DeleteMultipleReceivableConfigData = () => {
    if (checkedRows.length == 0) {
      ToastError("Please select record");
    } else {
      setOpenMultipleDeleteConfirmBox(true);
    }
  };

  const DeleteMultipleFunction = () => {
    deleteMultipleReceivableConfigById(checkedRows).then((res) => {
      setCheckedRows([]);
      setCheckboxRows({});
      reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
      console.log("checked rows ", checkedRows);
      console.log("check box rows ", checkboxRows);
    });
    setOpenMultipleDeleteConfirmBox(false);
  };

  const DeleteReceivableConfigData = (row) => {
    setOpenDeleteConfirmBox(true);
    setSelectedData(row);
  };
  const DeleteFunction = () => {
    console.log("ee");
    DeleteReceivableConfigById(selectedData._id).then((res) => {
      reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
    });
    setOpenDeleteConfirmBox(false);
  };

  const EditReceivableConfig = (row) => {
    GetReceivableConfigById(row._id).then((res) => {
      console.log(res);
      setOpenDrawer(true);
      setFormType("edit");
      setSelectedData(res.data);
    });
  };

  {
    /*changes by sankarNagarajan */
  }
  const DisableReceivableConfigFunction = (selectedDate) => {
    const requesttype = selectedData.isEnabled ? "true" : "false";
    const headers = {
      requesttype: requesttype,
      disableDate: selectedDate,
    };
    // console.log("headers ", headers);
    // return true;
    // Changed by Arun
    if (checkedRows.length > 0) {
      disableMultipleReceivableConfigById(checkedRows, headers).then((res) => {
        setCheckedRows([]);
        setCheckboxRows({});
        reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
        setOpenConfirmBox(false);
      });
    } else {
      DisableReceivableConfig(selectedData._id, headers).then((res) => {
        reqType === "DISABLED" ? DisableFunction() : ActiveFunction();
        setOpenConfirmBox(false);
      });
    }
  };

  // search receivable added by gokul...

  useEffect(() => {
    // Skip if reqType is not set yet (initial mount) - let the second useEffect handle initial load
    if (!reqType) {
      return;
    }

    // Clear any pending debounce timeout
    if (filterDebounceTimeoutRef.current) {
      clearTimeout(filterDebounceTimeoutRef.current);
    }

    // Debounce the API call to batch rapid filter changes (e.g., when both filters are selected quickly)
    filterDebounceTimeoutRef.current = setTimeout(() => {
      const companyId = selectedCompany?._id || selectedCompany;
      const bookingCodeId = selectedBookingCode?._id || selectedBookingCode;
      const subBookingCodeId =
        selectedSubBookingCode?._id || selectedSubBookingCode;

      // Determine finalCompanyId:
      // 1. If company is selected, always use it (even if booking code is also selected)
      // 2. If booking code is selected but no company, use "undefined" to allow filtering by booking code alone
      // 3. If neither is selected, skip API call (unless explicitly clearing in handleClearSingleFilter)
      let finalCompanyId;
      if (companyId && companyId !== null && companyId !== undefined) {
        // Company is selected - always use it (this ensures both filters work together)
        finalCompanyId = companyId;
      } else if (bookingCodeId || subBookingCodeId) {
        // No company but booking code is selected - use "undefined" to allow filtering by booking code
        finalCompanyId = "undefined";
      } else {
        // No filters selected - skip API call
        return;
      }

      // Build request params - always include booking code if selected (to combine with company filter)
      const requestParams = {
        requestType: reqType,
      };

      if (bookingCodeId) {
        requestParams.bookingCodeId = bookingCodeId;
      }
      if (subBookingCodeId) {
        requestParams.subBookingCodeId = subBookingCodeId;
      }

      // Create a unique key for this API call to prevent duplicates
      const apiCallKey = JSON.stringify({
        companyId: finalCompanyId,
        bookingCodeId: bookingCodeId || null,
        subBookingCodeId: subBookingCodeId || null,
        requestType: reqType,
      });

      // Skip if this exact API call was already made
      if (lastApiCallParamsRef.current === apiCallKey) {
        return;
      }

      // Store this API call parameters
      lastApiCallParamsRef.current = apiCallKey;

      // Make API call with company ID (or "undefined" if filtering by booking code without company)
      GetReceivableConfigByCompanyId(finalCompanyId, requestParams)
        .then((res) => {
          const formattedData = res.data.map((e) => {
            return {
              ...e,
              ActiveDate: moment(e.activeDate).format("DD/MM/YYYY"),
              ...(e.disableDate &&
                reqType === "DISABLED" && {
                DisableDate: moment(e.disableDate).format("DD/MM/YYYY"),
              }),
            };
          });
          setPolicyList(formattedData);
        })
        .catch((err) => {
          console.error("Error fetching receivable config:", err);
          // Reset the ref on error so the call can be retried
          lastApiCallParamsRef.current = null;
        });
    }, 200); // 200ms debounce to batch rapid filter changes

    // Cleanup function
    return () => {
      if (filterDebounceTimeoutRef.current) {
        clearTimeout(filterDebounceTimeoutRef.current);
      }
    };
  }, [selectedBookingCode, selectedSubBookingCode, selectedCompany, reqType]);

  useEffect(() => {
    setOpenLoader(true);
    setReqType("ACTIVE");
    // Initial load - use "undefined" to get all data when no filters are selected
    const companyId = selectedCompany?._id || selectedCompany;
    const finalCompanyId =
      companyId === null || companyId === undefined ? "undefined" : companyId;
    GetReceivableConfigByCompanyId(finalCompanyId, {
      requestType: "ACTIVE",
    })
      .then((res) => {
        const formattedData = res.data.map((e) => {
          return {
            ...e,
            ActiveDate: moment(e.activeDate).format("DD/MM/YYYY"),
          };
        });

        setPolicyList(formattedData);
      })
      .catch((error) => {
        console.error("Error fetching user config:", error);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  }, []);

  const handleMultiDelete = (items) => {
    console.log(items, "II");
    setCheckedRows(items);
  };

  const handleClearAllState = () => {
    setSelectedCompany(null);
    setSelectedBookingCode(null);
    setSelectedSubBookingCode(null);
    GetReceivableConfigByCompanyId("undefined", {
      requestType: reqType || "ACTIVE",
      bookingCodeId: null,
      subBookingCodeId: null,
    }).then((res) => {
      const formattedData = res.data.map((e) => {
        return {
          ...e,
          ActiveDate: moment(e.activeDate).format("DD/MM/YYYY"),
          ...(e.disableDate &&
            reqType === "DISABLED" && {
            DisableDate: moment(e.disableDate).format("DD/MM/YYYY"),
          }),
        };
      });
      setPolicyList(formattedData);
    });
  };

  const handleClearSingleFilter = (filterId) => {
    setOpenLoader(true);

    // Calculate what the values will be AFTER clearing (before updating state)
    let companyId, bookingCodeId, subBookingCodeId;

    if (filterId === 1) {
      // Clearing company - all filters should be cleared (match initial load exactly)
      setSelectedCompany(null);
      setSelectedBookingCode(null);
      setSelectedSubBookingCode(null);
      // Match initial load: when selectedCompany is null, selectedCompany?._id = undefined
      companyId = undefined;
      bookingCodeId = undefined;
      subBookingCodeId = undefined;
    } else if (filterId === 2) {
      // Clearing booking code - also clear sub booking code
      setSelectedBookingCode(null);
      setSelectedSubBookingCode(null);
      // Keep company, clear booking codes
      companyId = selectedCompany?._id || selectedCompany;
      bookingCodeId = undefined;
      subBookingCodeId = undefined;
    } else if (filterId === 3) {
      // Clearing sub booking code only
      setSelectedSubBookingCode(null);
      // Keep company and booking code, clear sub booking code
      companyId = selectedCompany?._id || selectedCompany;
      bookingCodeId = selectedBookingCode?._id || selectedBookingCode;
      subBookingCodeId = undefined;
    }

    // Build request params - match initial load format exactly (only requestType initially)
    const requestParams = {
      requestType: reqType || "ACTIVE",
    };

    // Only add to params if they have truthy values (match initial load - undefined values are not included in headers)
    if (bookingCodeId) {
      requestParams.bookingCodeId = bookingCodeId;
    }
    if (subBookingCodeId) {
      requestParams.subBookingCodeId = subBookingCodeId;
    }

    // Convert null/undefined to "undefined" string to prevent /null in URL
    // Backend should handle "undefined" to return all data when no company filter is applied
    const finalCompanyId =
      companyId === null || companyId === undefined ? "undefined" : companyId;

    // Make API call - use "undefined" string when no company is selected to get all data
    GetReceivableConfigByCompanyId(finalCompanyId, requestParams)
      .then((res) => {
        const formattedData = res.data.map((e) => {
          return {
            ...e,
            ActiveDate: moment(e.activeDate).format("DD/MM/YYYY"),
            ...(e.disableDate &&
              reqType === "DISABLED" && {
              DisableDate: moment(e.disableDate).format("DD/MM/YYYY"),
            }),
          };
        });
        setPolicyList(formattedData);
      })
      .catch((err) => {
        console.error("Error fetching receivable config:", err);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };

  const handleSaveAllFilter = () => {
    const companyId = selectedCompany?._id || selectedCompany;
    const bookingCodeId = selectedBookingCode?._id || selectedBookingCode;
    const subBookingCodeId =
      selectedSubBookingCode?._id || selectedSubBookingCode;

    // Determine finalCompanyId:
    // 1. If company is selected, always use it (even if booking code is also selected)
    // 2. If booking code is selected but no company, use "undefined" to allow filtering by booking code alone
    // 3. If neither is selected, skip API call
    let finalCompanyId;
    if (companyId && companyId !== null && companyId !== undefined) {
      // Company is selected - always use it (this ensures both filters work together)
      finalCompanyId = companyId;
    } else if (bookingCodeId || subBookingCodeId) {
      // No company but booking code is selected - use "undefined" to allow filtering by booking code
      finalCompanyId = "undefined";
    } else {
      // No filters selected - skip API call
      return;
    }

    // Build request params - always include booking code if selected (to combine with company filter)
    const requestParams = {
      requestType: reqType || "ACTIVE",
    };

    if (bookingCodeId) {
      requestParams.bookingCodeId = bookingCodeId;
    }
    if (subBookingCodeId) {
      requestParams.subBookingCodeId = subBookingCodeId;
    }

    GetReceivableConfigByCompanyId(finalCompanyId, requestParams).then(
      (res) => {
        const formattedData = res.data.map((e) => {
          return {
            ...e,
            ActiveDate: moment(e.activeDate).format("DD/MM/YYYY"),
            ...(e.disableDate &&
              reqType === "DISABLED" && {
              DisableDate: moment(e.disableDate).format("DD/MM/YYYY"),
            }),
          };
        });
        setPolicyList(formattedData);
      }
    );
  };
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  const filterBoxData = [
    {
      id: 1,
      label: "Select Company",
      data: companyDetails,
      setState: setSelectedCompany,
      value: selectedCompany,
      type: "input",
      variation: "single",
    },
    {
      id: 2,
      label: "Select Booking Code",
      data: bookingCodeDetails,
      setState: setSelectedBookingCode,
      value: selectedBookingCode,
      type: "input",
      variation: "single",
    },
    {
      id: 3,
      label: "Select SubBooking Code",
      data: subBookingCodeDetails,
      setState: setSelectedSubBookingCode,
      value: selectedSubBookingCode,
      type: "input",
      variation: "single",
    },
  ];
  console.log("filtereddata", FilteredData);

  const activeFiltersCount = [
    selectedCompany,
    selectedBookingCode,
    selectedSubBookingCode,
  ].filter(Boolean).length;

  return (
    <>
      <div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ position: "relative", zIndex: 1, mt: 0 }}>
            <Grid container className="Master_Card_Container">
              <Grid
                container
                alignItems={"center"}
                className="Master_Card_Sub_Container"
                sx={{ mb: 2 }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <Typography className="Master_Card_Tittle">
                    Receivable Configuration
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={8}
                  className="d-flex"
                  justifyContent={{
                    xs: "start",
                    sm: "flex-end",
                    md: "flex-end",
                  }}
                >
                  <Stack
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    spacing={2}
                    mt={{ xs: 2, sm: 2, md: 0 }}
                  >
                    <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        startIcon={
                          <DeleteIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={() => DeleteMultipleReceivableConfigData()}
                      >
                        Delete
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button  w-100"
                        startIcon={
                          <NotInterestedIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={() => DisableMultipleReceivableConfigData()}
                      >
                        Disable
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <Badge
                            badgeContent={activeFiltersCount}
                            color="error"
                            sx={{
                              "& .MuiBadge-badge": {
                                right: 5,
                                top: 3,
                                width: "14px",
                                height: "14px",
                                minWidth: "14px",
                                borderRadius: "50%",
                                fontSize: "8.91px",
                                fontWeight: "600",
                                backgroundColor: "#E50000",
                                color: "#fff",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <FilterListIcon sx={{ marginRight: "1.5px" }} />
                          </Badge>
                        }
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        Filters
                      </Button>
                      <Button
                        className="Master_Card_Filter_Button w-100"
                        sx={{ width: "102px", height: "40px", gap: "8px" }}
                        startIcon={
                          <CloudDownloadOutlinedIcon
                            sx={{
                              color: "#344054",
                            }}
                          />
                        }
                      >
                        <CSVLink
                          style={{ textDecoration: "none", color: "inherit" }}
                          {...csvFile}
                        >
                          Export
                        </CSVLink>
                      </Button>
                      <Button
                        className="Master_Card_create_Button w-100"
                        startIcon={
                          <AddIcon
                            sx={{
                              marginRight: "1.5px",
                            }}
                          />
                        }
                        onClick={() => {
                          setOpenDrawer(true);
                          setFormType("add");
                          setSelectedData({});
                        }}
                      >
                        Create
                      </Button>
                      {/* <IconButton
                        sx={{
                          border: "1px solid #D0D5DD",
                          borderRadius: "8px",
                          padding: "8px",
                        }}
                      >
                        <ViewColumnOutlinedIcon />
                      </IconButton> */}
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>

              {/* Filter Section */}
              {showFilter && (
                <Box
                  sx={{
                    mb: 2,
                    overflow: "visible",
                    position: "relative",
                    zIndex: 1200,
                    minHeight: "60px",
                    width: "100%",
                  }}
                >
                  <FilterBox
                    filterData={filterBoxData}
                    type={"single"}
                    handleClearAllState={handleClearAllState}
                    handleSaveAllFilter={handleSaveAllFilter}
                    handleClearSingleFilter={handleClearSingleFilter}
                    horizontalLayout={true}
                    hideHeader={true}
                    hideInput={true}
                    alwaysOpen={true}
                    autoApply={false}
                  />
                </Box>
              )}

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
              <Grid
                container
                alignItems={"center"}
                justifyContent={"space-between"}
                className="Master_Card_Sub_Container"
              >
                {/* <Grid item xs={12} sm={8} md={8}></Grid> */}
                <TabFilter
                  options={FilterOption}
                  selectedTab={selectedTab}
                  onTabChange={handleTabChange}
                />
                <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                  <Input
                    focused="false"
                    className="w-100 Master_Card_Input"
                    id="standard-adornment-password"
                    // onChange={onSearch}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setPage(0);
                    }}
                    disableUnderline={true}
                    placeholder="Search User"
                    startAdornment={
                      <InputAdornment
                        position="start"
                        sx={{ marginRight: "0px" }}
                      >
                        <IconButton aria-label="toggle password visibility">
                          <SearchIcon
                            sx={{
                              fontSize: "20px",
                            }}
                          />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
              <MasterCommonTable
                tableConfig={tableConfig}
                data={FilteredData}
                columns={getHeadCells(selectedTab)}
                // isServerSide={true}
                // handleOnClickBehaviour={OpenPolicyFile}
                handleEdit={EditReceivableConfig}
                handleDelete={DeleteReceivableConfigData}
                handleApprove={DisableReceivableConfigData}
                handleMultiDelete={handleMultiDelete}
                // handleButton2={handleButton}
                tableTotalCount={filter.fn(policyList)?.length || 0}
                loading={openLoader}
              />
            </Grid>
          </Box>
        </Box>
      </div>
      {/* <Loader open={openLoader} /> */}
      <Dialog
        open={openDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        // PaperProps={{
        //   style: { maxWidth: "50%" },
        // }}
        PaperProps={{
          sx: {
            maxWidth: {
              xs: "80%",
              sm: "70%",
              md: "50%",
              lg: "60%",
            },
          },
        }}
      >
        {openDrawer ? (
          <AddReceivableConfig
            setOpenDrawer={setOpenDrawer}
            selectedUser={selectedUser}
            ActiveFunction={ActiveFunction}
            formType={formType}
            selectedData={selectedData}
          />
        ) : null}
      </Dialog>
      {/* <Drawer
        open={openDrawer}
        sx={{
          zIndex: 100,
        }}
        anchor="right"
        PaperProps={{
          sx: { width: { xs: "100%", sm: "50%" } },
        }}
      >
        {openDrawer ? (
          <AddReceivableConfig
            setOpenDrawer={setOpenDrawer}
            selectedUser={selectedUser}
            ActiveFunction={ActiveFunction}
          />
        ) : null}
      </Drawer> */}
      <ConfirmBox
        setDisabledDate={setDisabledDate}
        disabledDate={disabledDate}
        mode="picker"
        open={openConfirmBox}
        title="Disable"
        content={
          disabledDate === "React-disable"
            ? "Please select the date ... !"
            : "Are you sure want to disable"
        }
        confirmButton="Disable"
        setOpenConfirmBox={setOpenConfirmBox}
        Function={DisableReceivableConfigFunction}
        icon={<NotInterestedIcon />}
        color="error"
        img={DisabledImage}
        subContent="Select a valid date before proceeding."
      />
      <ConfirmBox
        open={openDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenDeleteConfirmBox}
        Function={DeleteFunction}
        icon={<DeleteIcon />}
        color="error"
      />
      {/*changes by sankarNagarajan */}
      <ConfirmBox
        open={openMultipleDeleteConfirmBox}
        title="Delete"
        content="Are you sure you want to delete this?"
        subContent="This action cannot be undone. Once deleted, the data will be permanently removed from the system."
        img={DeleteImage}
        confirmButton="Delete"
        setOpenConfirmBox={setOpenMultipleDeleteConfirmBox}
        Function={DeleteMultipleFunction}
        icon={<DeleteIcon />}
        color="error"
      />
    </>
  );
};
export default ReceivableConfig;
